'use strict';

import ProductDetails from '../product-details/product-details';

export default class ButtonCounter {
    constructor() {
        let productDetails = new ProductDetails();
        let maxProdCount = parseInt($('#MaxAllowedProductQuantity').val());
        $('body').on('mousedown', '.counter-btn', function() {
            if($('.view-order-review').length == 0) { 
                let $button = $(this),
                $input = $button.parent().siblings('.counter-value'),
                newVal;
                
                if ($button.hasClass('btn-plus')) 
                    newVal = increment($input);
                else  
                newVal = decrement($input);

                if(!parseInt(newVal))
                    return false;

                $input.val(newVal);
    
                if ($button.closest('.product-quantity__value').length) {
                    productDetails.calculatePricePerProduct();
                    productDetails.updateProducts();
                }

                if ($button.closest('.product-details__header').length) {
                    productDetails.updateProducts();
                }
            }
        });

        // Allow only integers in input number
        $('body').on('keypress', '.counter-value', function(e) {
            let verified = (e.which == 8 || e.which == undefined || e.which == 0) ? null : String.fromCharCode(e.which).match(/[^0-9]/);

            if (verified) {
                e.preventDefault();
            }
        });

        // set zero as default value
        $('.product-details').on('change', '.counter-value', function() {
            let $this = $(this),
                inputValue = $this.val();

            if (inputValue == '')
                $this.val(0);
            else if ( inputValue >= maxProdCount) 
                $this.val(maxProdCount);            
        });

        $('.product-details').on('focus keyup', '.counter-value', function() {
            let $this = $(this),
                quantity = $this.val(),
                $flavourEnclosure = $this.closest('.product-flavour-quantity__enclosure');

            let isSufficient = isStockSufficient($flavourEnclosure, quantity),
                $selectedStockLabel = $flavourEnclosure.find('.stock-quantity__label');

            displayOutStockLabel(isSufficient, $selectedStockLabel); 
        });

        let decrement = function($input){
            let oldValue = $input.val(),
                incrementValue = Number.parseInt($input.data("quantity-increment")) || 1,
                newValue;

            if($input.data('decrement') == false)
                return true;

            // Don't allow decrementing below one
            if (oldValue > incrementValue) 
                newValue = parseInt(oldValue) - incrementValue;
            else
                newValue = incrementValue;

            let $flavourEnclosure = $input.closest('.product-flavour-quantity__enclosure'),
                isSufficient = isStockSufficient($flavourEnclosure, newValue),
                $selectedStockLabel = $flavourEnclosure.find('.stock-quantity__label');

            displayOutStockLabel(isSufficient, $selectedStockLabel); 

            return newValue
        }

        let increment = function($input){
            let oldValue = parseInt($input.val()),
                incrementValue = Number.parseInt($input.data("quantity-increment")) || 1,
                quantity = oldValue + incrementValue,
                newValue;

            let $flavourEnclosure = $input.closest('.product-flavour-quantity__enclosure');

            // Don't allow incrementing if value cannot be incremented
            if ($input.data('increment') == false && (oldValue == $input.data('quantity')))
                return true;

            if(!isStockSufficient($flavourEnclosure,quantity))
                return true;

            if (quantity >= maxProdCount)
                return true;
                //newValue = maxProdCount;
            else
                newValue = parseInt(oldValue) + incrementValue;
    
            return newValue;
        }

        let isStockSufficient = function($flavourEnclosure, quantity){
            return true;
            let $selectedFlavour = $flavourEnclosure.find('li.selected'),
                inStock = parseInt($selectedFlavour.attr('data-in-stock'));

            return quantity > inStock  ? false : true;
        }

        let displayOutStockLabel = function(isSufficient, $selectedStockLabel){

            if(!isSufficient)
                $selectedStockLabel.addClass('show');
            else
                $selectedStockLabel.removeClass('show');
        }
    }
}
